import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  FormControl, OutlinedInput, InputLabel, InputAdornment, Button,
} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import Link from '@material-ui/core/Link';
// import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import SearchIcon from '@material-ui/icons/Search';
import Actions from '../actions';
import Drawer from './Drawer';
import CallModal from './Modal';

import { getISTOfUTC, getWeekDays } from '../utils/util';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  wrapText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100px',
  },
  tableCell: {
    width: '10%',
    background: '#f4f4f4',
  },
  tableCellArrow: {
    width: '2rem',
    background: '#f4f4f4',
  },
});
const StyledTableCell = withStyles((theme) => {
  return {
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      width: '10%',
    },
    body: {
      fontSize: 14,
      width: '10%',
    },
  };
})(TableCell);

const StyledTableRow = withStyles((theme) => {
  return {
    root: {
      backgroundColor: theme.palette.action.hover,
    },
  };
})(TableRow);

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
      overflow: 'hidden',
    },
    margin: {
      margin: theme.spacing(2),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: '25ch',
      padding: 0,
    },
    container: {
      width: '100%',
    // maxHeight: window.innerHeight-120,
    },
  };
});

let fetching = '';
function createData(data) {
  let slots = [];
  if (!fetching) slots = data.slots.filter((slot) => { return slot.callType === data._id; });
  return { ...data, slots };
}

const getTime = (dateTimeStr) => {
  if (!dateTimeStr) return '';
  let hour = parseInt(dateTimeStr.substring(11, 13), 10);
  hour = hour % 12 !== 0 ? (hour % 12) : 12;
  const prefix = hour >= 10 ? '' : '0';
  const minute = dateTimeStr.substring(14, 16);
  const midday = parseInt(dateTimeStr.substring(11, 13), 10) < 12 ? 'AM' : 'PM';
  return `${prefix}${hour}:${minute} ${midday}`;
};

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <>
      <TableRow className={classes.root}>
        <TableCell className={classes.tableCellArrow} width={50}>
          <IconButton aria-label="expand row" size="small" onClick={() => { return setOpen(!open); }}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell className={classes.tableCell}>{row.name}</TableCell>
        <TableCell className={classes.tableCell}>{row.title}</TableCell>
        <TableCell className={classes.tableCell}>
          <Tooltip arrow TransitionComponent={Zoom} title={row.description}>
            <div className={classes.wrapText}>{row.description}</div>
          </Tooltip>
        </TableCell>
        <TableCell className={classes.tableCell}>{row.maxParticipants}</TableCell>
        <TableCell className={classes.tableCell}>{row.platform}</TableCell>
        <TableCell className={classes.tableCell}>
          <Tooltip arrow TransitionComponent={Zoom} title={row.img}>
            <div className={classes.wrapText}>
              <Link underline="none" href={row.img} target="_blank">{row.img}</Link>
            </div>
          </Tooltip>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <Tooltip arrow TransitionComponent={Zoom} title={row.shareText}>
            <div className={classes.wrapText}>{row.shareText}</div>
          </Tooltip>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <Tooltip arrow TransitionComponent={Zoom} title={row.shareImg}>
            <div className={classes.wrapText}>
              <Link underline="none" href={row.shareImg} target="_blank">{row.shareImg}</Link>
            </div>
          </Tooltip>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <Button variant="outlined" color="primary" onClick={() => { return props.handleEdit('type', row); }}>Edit</Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, width: 20 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="body1" align="center" gutterBottom component="div" style={{ marginTop: 20 }}>
                Call slots for:
                {' '}
                <b>{row.name}</b>
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>URL</StyledTableCell>
                    <StyledTableCell>Frequency</StyledTableCell>
                    <StyledTableCell>Active</StyledTableCell>
                    <StyledTableCell>Duration</StyledTableCell>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Time</StyledTableCell>
                    <StyledTableCell>Upcoming Cancelled Dates</StyledTableCell>
                    <StyledTableCell>Moderator</StyledTableCell>
                    <StyledTableCell>Countries</StyledTableCell>
                    <StyledTableCell>IsPaid</StyledTableCell>
                    <StyledTableCell>IsTherapistCall</StyledTableCell>
                    <StyledTableCell />
                    {/* <StyledTableCell></StyledTableCell> */}
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {row.slots.map((slot) => {
                    return (
                      <StyledTableRow key={slot._id}>
                        <StyledTableCell component="th" scope="row">
                          <Tooltip arrow TransitionComponent={Zoom} title={slot.url}>
                            <div className={classes.wrapText}>
                              <Link underline="none" href={slot.url} target="_blank">{slot.url && slot.url}</Link>
                            </div>
                          </Tooltip>
                        </StyledTableCell>
                        <StyledTableCell>
                          {
                            getWeekDays((slot.weekDays || []).map((wdd) => { return getISTOfUTC(wdd); })).join(',')
                          }
                        </StyledTableCell>
                        <StyledTableCell>{slot.isActive && slot.isActive ? 'Active' : 'Inactive'}</StyledTableCell>
                        <StyledTableCell>
                          {slot.duration && slot.duration}
                          {' '}
                          mins
                        </StyledTableCell>
                        <StyledTableCell>
                          {slot.dateTime && slot.dateTime.substring(0, 10)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {getTime(slot.dateTime)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {slot.cancelledDates && slot.cancelledDates.map((datestr) => {
                            const today = new Date();
                            let date = getISTOfUTC(datestr);
                            date = new Date(date) >= today ? date : undefined;
                            return (<p key={datestr}>{date && date.toISOString().substring(0, 10)}</p>);
                          })}
                        </StyledTableCell>
                        <StyledTableCell>
                          {slot.moderator && slot.moderator.name}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Tooltip arrow TransitionComponent={Zoom} title={slot.countries && slot.countries.join(', ')}>
                            <div className={classes.wrapText}>{slot.countries && slot.countries.join(', ')}</div>
                          </Tooltip>
                        </StyledTableCell>
                        <StyledTableCell>{slot.isPaid ? 'True' : 'False'}</StyledTableCell>
                        <StyledTableCell>{slot.isTherapistCall ? 'True' : 'False'}</StyledTableCell>
                        <StyledTableCell>
                          <Button variant="contained" color="primary" onClick={() => { return props.handleEdit('slot', slot); }}>Edit</Button>
                        </StyledTableCell>
                        {/* <StyledTableCell>
                      <IconButton aria-label="delete" color="secondary" onClick={()=>props.handleEdit('delete',slot._id)}><DeleteIcon /></IconButton>
                      </StyledTableCell> */}
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
function CallTypesTable(props) {
  const [editing, setEditing] = useState('');
  const [editData, setData] = useState({});
  const [open, setOpen] = useState(false);
  useEffect(() => {
    props.getCallSlots();
    props.getCallTypes();
    // eslint-disable-next-line
  }, [open]);
  const rows = [];
  const classes = useStyles();
  const { callTypes } = props;
  const slots = props.callSlots && props.callSlots.map((slot) => {
    let dateUTC = new Date(slot.dateTime);
    dateUTC = dateUTC.getTime();
    let dateTime = new Date(dateUTC);
    dateTime.setHours(dateTime.getHours() + 5);
    dateTime.setMinutes(dateTime.getMinutes() + 30);
    dateTime = dateTime.toISOString();
    // console.log(`${slot.url} ${slot.dateTime} ${dateTime}`);
    return { ...slot, dateTime };
  });
  fetching = props.fetching;
  // eslint-disable-next-line no-unused-expressions
  callTypes && callTypes.forEach((callType) => {
    rows.push(createData({ ...callType, slots }));
  });
  const [search, searchUpdate] = useState('');

  function handelSearch(e) {
    searchUpdate(e.target.value);
  }
  const filteredRows = rows.filter(
    (row) => {
      return (row.name && row.name.toLowerCase().indexOf(search.toLowerCase()) !== -1);
    },
  );

  function handleClose() {
    setEditing('');
    setOpen(false);
  }

  function handleDelete(_id) {
    props.deleteCallSlot(_id).then(() => { return props.getCallSlots(); });
    handleClose();
  }

  function handleEdit(call, data) {
    // eslint-disable-next-line no-unused-expressions
    call ? setEditing(call) : setEditing('');
    // eslint-disable-next-line no-unused-expressions
    data && setData(data);
    setOpen(true);
  }

  return (
    <Drawer>
      {open ? <CallModal data={editData} editing={editing} modalClosed={handleClose} handleDelete={handleDelete} /> : null}
      <Paper className={classes.root}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', width: '100%', background: 'inherit',
        }}
        >
          <Typography variant="h4" className={classes.margin}>
            Call Details
          </Typography>
          <FormControl className={[classes.margin, classes.textField].join(' ')} variant="outlined" size="small">
            <InputLabel htmlFor="outlined-adornment-calltype">Search callType</InputLabel>
            <OutlinedInput
              id="outlined-adornment-calltype"
              type="text"
              value={search}
              onChange={(e) => { return handelSearch(e); }}
              endAdornment={(
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
                  )}
              labelWidth={90}
            />
          </FormControl>
        </div>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="Calls table">
            <TableHead style={{ width: '100%' }}>
              <TableRow>
                <StyledTableCell />
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Title</StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
                <StyledTableCell>Max. Participants</StyledTableCell>
                <StyledTableCell>Platform</StyledTableCell>
                <StyledTableCell>Image Url.</StyledTableCell>
                <StyledTableCell>Share Text</StyledTableCell>
                <StyledTableCell>Share Image Url</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.map((row) => {
                return (
                  <Row handleEdit={handleEdit} handleDelete={handleDelete} key={row._id} row={row} />
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Drawer>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    callTypes: state.callTypes.data,
    callSlots: state.callSlots.data,
    fetching: state.callSlots.fetching,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CallTypesTable);
